import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';

gsap.registerPlugin(Flip);
gsap.registerPlugin(MorphSVGPlugin);
/* mobile svg */
const transitionMobile = document?.querySelector('#transition_mobile');
const backgroundMobile = document?.querySelector('#step_mobile');
const blocFullMobile = document?.querySelector('#block_full_mobile');
/* desktop svg */
const transitionDesktop = document?.querySelector('#transition_desktop');
const backgroundDesktop = document?.querySelector('#step_desktop');
const blocFullDesktop = document?.querySelector('#block_full_desktop');

const stepOne = document.querySelector('#intro-q1');
const stepTwo = document.querySelector('#intro-q2');
const stepThree = document.querySelector('#intro-q3');
const stepFour = document.querySelector('#recap-form');
const uiWrapper = document.querySelector('#ui-wrapper');
const uiStep1 = document.querySelector('#ui-step-1');
const uiStep2 = document.querySelector('#ui-step-2');
const uiStep3 = document.querySelector('#ui-step-3');

function animateStep1(out?: boolean) {
  const header = stepOne?.querySelector('.header-q-form');
  const title = stepOne?.querySelector('.form-title');
  const swiper = stepOne?.querySelector('.swiper-container');
  const bntValidate = stepOne?.querySelector('#validate-q1');

  if (!out) {
    gsap.set(uiStep1, { width: '0%' });
    gsap.set(uiStep2, { width: '0%' });
    gsap.set(uiStep3, { width: '0%' });
    gsap.set('#background-svg', {
      backgroundColor: '#EDCC77',
    });
    //   // on s'assure de la shape de base re
    gsap.set(transitionMobile, {
      morphSVG: blocFullMobile,
      fill: '#E23C83',
      y: '100%',
      scaleY: 0,
      opacity: 1,
    });
    gsap.set(transitionDesktop, {
      morphSVG: blocFullDesktop,
      fill: '#E23C83',
      y: '100%',
      scaleY: 0,
      opacity: 1,
    });
    gsap.set([header, title, swiper, bntValidate, backgroundMobile, uiWrapper], { opacity: 0 });
    stepOne?.classList.remove('hide');
    gsap.to([transitionMobile, transitionDesktop], {
      y: '0',
      scaleY: 1,
      duration: 0.25,
      ease: 'power1.in',
    });
    gsap.to(uiWrapper, { opacity: 1, duration: 0.25, ease: 'power1.in' }, '+=.250');
    // transition vers le background de base
    gsap.to(
      transitionMobile,
      {
        duration: 1,
        morphSVG: {
          shape: transitionMobile,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '+=.250'
    );
    gsap.to(
      transitionDesktop,
      {
        duration: 1,
        morphSVG: {
          shape: transitionDesktop,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '<'
    );
    gsap.to(uiStep1, { width: '100%', duration: 1, ease: 'power3.inOut' }, '-=.750');
    gsap.to(
      transitionMobile,
      {
        duration: 1,
        morphSVG: {
          shape: backgroundMobile,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '-=.550'
    );
    gsap.to(
      transitionDesktop,
      {
        duration: 1,
        morphSVG: {
          shape: backgroundDesktop,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '<'
    );
    gsap.fromTo(
      [header, title, swiper],
      { opacity: 0 },
      { opacity: 1, duration: 0.5, ease: 'power1.out' },
      '-=.550'
    );
    gsap.fromTo(
      [bntValidate],
      { opacity: 0 },
      { opacity: 0.4, duration: 0.5, ease: 'power1.out' },
      '-=.550'
    );
  } else {
    // animation de sortie on va fade
    gsap.to([header, title, swiper, bntValidate], {
      opacity: 0,
      duration: 0.5,
      ease: 'power1.out',
    });
  }
}

function animateStep2(out?: boolean) {
  const header = stepTwo?.querySelector('.header-q-form');
  const title = stepTwo?.querySelector('.form-title');
  const swiper = stepTwo?.querySelector('.swiper-container');
  const bntValidate = stepTwo?.querySelector('#validate-q2');
  if (!out) {
    // on repasse par la shape de base
    gsap.set([header, title, swiper, bntValidate], { opacity: 0 });
    stepOne.classList.add('hide');
    stepTwo?.classList.remove('hide');
    gsap.to(transitionMobile, {
      duration: 1,
      morphSVG: {
        shape: blocFullMobile,
        type: 'linear',
      },
      ease: 'power3.inOut',
    });
    gsap.to(transitionDesktop, {
      duration: 1,
      morphSVG: {
        shape: blocFullDesktop,
        type: 'linear',
      },
      ease: 'power3.inOut',
    });
    gsap.to('#background-svg', {
      backgroundColor: '#FAB736',
      duration: 1,
      ease: 'power3.inOut',
      delay: 1,
    });

    gsap.to(
      transitionMobile,
      {
        fill: '#9A6CBE',
        duration: 1,
        morphSVG: {
          shape: transitionMobile,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '-=1'
    );
    gsap.to(
      transitionDesktop,
      {
        fill: '#9A6CBE',
        duration: 1,
        morphSVG: {
          shape: transitionDesktop,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '-=1'
    );
    gsap.to(uiStep2, { width: '100%', duration: 1, ease: 'power3.inOut' }, '-=.750');
    gsap.to(
      transitionMobile,
      {
        duration: 1,
        morphSVG: {
          shape: backgroundMobile,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '+=.250'
    );
    gsap.to(
      transitionDesktop,
      {
        duration: 1,
        morphSVG: {
          shape: backgroundDesktop,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '<'
    );
    gsap.fromTo(
      [header, title, swiper],
      { opacity: 0 },
      { opacity: 1, duration: 0.5, ease: 'power1.out' },
      '-=.550'
    );
    gsap.fromTo(
      [bntValidate],
      { opacity: 0 },
      { opacity: 0.4, duration: 0.5, ease: 'power1.out' },
      '-=.550'
    );
  } else {
    gsap.to([header, title, swiper, bntValidate], {
      opacity: 0,
      duration: 0.5,
      ease: 'power1.out',
    });
  }
}

function animateStep3(out?: boolean) {
  const header = stepThree?.querySelector('.header-q-form');
  const title = stepThree?.querySelector('.form-title');
  const swiper = stepThree?.querySelector('.swiper-container');
  const bntValidate = stepThree?.querySelector('#validate-q3');
  if (!out) {
    // on repasse par la shape de base
    gsap.set([header, title, swiper, bntValidate], { opacity: 0 });
    stepTwo.classList.add('hide');
    stepThree?.classList.remove('hide');
    gsap.to(transitionMobile, {
      duration: 1,
      morphSVG: {
        shape: blocFullMobile,
        type: 'linear',
      },
      ease: 'power3.inOut',
    });
    gsap.to(
      transitionDesktop,
      {
        duration: 1,
        morphSVG: {
          shape: blocFullDesktop,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '<'
    );
    gsap.to('#background-svg', {
      backgroundColor: '#FFBABA',
      duration: 1,
      ease: 'power3.inOut',
      delay: 1,
    });

    gsap.to(
      transitionMobile,
      {
        fill: '#9A6CBE',
        duration: 1,
        morphSVG: {
          shape: transitionMobile,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '-=1'
    );
    gsap.to(
      transitionDesktop,
      {
        fill: '#9A6CBE',
        duration: 1,
        morphSVG: {
          shape: transitionDesktop,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '-=1'
    );
    gsap.to(uiStep3, { width: '100%', duration: 1, ease: 'power3.inOut' }, '-=.750');
    gsap.to(
      transitionMobile,
      {
        duration: 1,
        morphSVG: {
          shape: backgroundMobile,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '+=.250'
    );
    gsap.to(
      transitionDesktop,
      {
        duration: 1,
        morphSVG: {
          shape: backgroundDesktop,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '<'
    );
    gsap.fromTo(
      [header, title, swiper],
      { opacity: 0 },
      { opacity: 1, duration: 0.5, ease: 'power1.out' },
      '-=.550'
    );
    gsap.fromTo(
      [bntValidate],
      { opacity: 0 },
      { opacity: 0.4, duration: 0.5, ease: 'power1.out' },
      '-=.550'
    );
  } else {
    gsap.to(transitionMobile, {
      duration: 1,
      morphSVG: {
        shape: blocFullMobile,
        type: 'linear',
      },
      ease: 'power3.inOut',
    });
    gsap.to(
      transitionDesktop,
      {
        duration: 1,
        morphSVG: {
          shape: blocFullDesktop,
          type: 'linear',
        },
        ease: 'power3.inOut',
      },
      '<'
    );
    gsap.to([header, title, swiper, bntValidate, uiWrapper], {
      opacity: 0,
      duration: 0.5,
      ease: 'power1.out',
    });
    gsap.to(
      transitionMobile,
      {
        opacity: 0,
        duration: 0.5,
        ease: 'power1.out',
      },
      '-=.5'
    );
    gsap.to(
      transitionDesktop,
      {
        opacity: 0,
        duration: 0.5,
        ease: 'power1.out',
      },
      '<'
    );
    gsap.to('#background-svg', {
      backgroundColor: '#EDF0D5',
      duration: 1,
      ease: 'power3.inOut',
    });
  }
}

function animateStep4(out?: boolean) {
  const header = stepFour?.querySelector('.header-q-form');
  const content = stepFour?.querySelector('.recap-form-wrapper');
  const footer = stepFour?.querySelector('.footer-q-form');
  if (!out) {
    gsap.set([header, content, footer], { opacity: 0 });
    stepFour?.classList.remove('hide');
    stepThree?.classList.add('hide');
    gsap.to([header, content, footer], { opacity: 1, duration: 0.5, ease: 'power1.out' });
    gsap.set(uiStep1, { width: '0%' });
    gsap.set(uiStep2, { width: '0%' });
    gsap.set(uiStep3, { width: '0%' });
  } else {
    gsap.to([header, content, footer], {
      opacity: 0,
      duration: 0.5,
      ease: 'power1.out',
      onComplete: () => {
        stepFour?.classList.add('hide');
      },
    });
    gsap.to('#background-svg', {
      backgroundColor: '#EDCC77',
      duration: 0.5,
      ease: 'power3.inOut',
    });
  }
}
export { animateStep1, animateStep2, animateStep3, animateStep4 };
